export default __webpack_public_path__ + "static/media/ThinkContractWBS.8f27266aadc235121c71b87ae5e67612.webp";